import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../models/api-response';
import { ErpDto, ErpWrite } from '../models/erp-dto';

@Injectable({ providedIn: 'root' })
export class ErpService {
  constructor(private httpClient: HttpClient) {}

  // Admin

  getById(erpId: number): Observable<ErpDto> {
    return this.httpClient.get<ErpDto>(`${environment.backendUrl}/api/admin/v1/erp/${erpId}`);
  }

  getByOperatorId(operatorId: number): Observable<ErpDto[]> {
    return this.httpClient.get<ErpDto[]>(`${environment.backendUrl}/api/admin/v1/erp/operator/${operatorId}`);
  }

  getBySupplierId(supplierId: number): Observable<ErpDto[]> {
    return this.httpClient.get<ErpDto[]>(`${environment.backendUrl}/api/admin/v1/erp/supplier/${supplierId}`);
  }

  getByOrganisationId(organisationId: number): Observable<ErpDto[]> {
    return this.httpClient.get<ErpDto[]>(`${environment.backendUrl}/api/admin/v1/erp/organisation/${organisationId}`);
  }

  create(data: ErpWrite): Observable<ErpDto> {
    return this.httpClient.post<ErpDto>(`${environment.backendUrl}/api/admin/v1/erp`, data);
  }

  delete(erpId: number): Observable<any> {
    return this.httpClient.delete<ApiResponse>(`${environment.backendUrl}/api/admin/v1/erp/${erpId}`);
  }

  // Operator

  operatorGet(): Observable<ErpDto[]> {
    return this.httpClient.get<ErpDto[]>(`${environment.backendUrl}/api/operator/v1/erp`);
  }
}
